module.exports = __webpack_public_path__ + "img/share_ico3.947033d0.png";